import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-413a3be8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: "detail",
  class: "changelog-popup__details"
}
const _hoisted_2 = { key: "list" }

import { computed, ref } from 'vue'
import { ChangelogView } from '@/models/changelog'
import BasePopup from '@/components/ui/BasePopup.vue'
import Item from './Item.vue'
import { backend } from '@/services/backend'
import { Changelog } from '@/models/interfaces'
import * as Mixpanel from '@/analytics/mixpanel/mixpanel'

export default /*#__PURE__*/_defineComponent({
  __name: 'Popup',
  props: {
    view: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  view: ChangelogView
};



// Note: in vue 3.5 we need to switch to useTemplateRef
const popup = ref<InstanceType<typeof BasePopup> | null>(null)

const selectedId = ref<string | null>(null)
const lastScrollPosition = ref<number>(0)
const containerRef = ref<HTMLElement | null>(null)

async function selectItem(item: Changelog): Promise<void> {
  // Store scroll position before any transition
  if (containerRef.value) {
    lastScrollPosition.value = containerRef.value.scrollTop
  }

  selectedId.value = item.id

  Mixpanel.trackChangelogItemClick(item)

  // If the item is historical or already read, we don't need to mark it as read
  if (item.is_historical || item.is_read) {
    return
  }

  await backend.markReadChangelog(item.id)

  // Update the item in the view
  item.is_read = true
  props.view.refreshIfNeeded(true)
}

const selectedItem = computed(() => {
  return props.view.data.find((item) => item.id === selectedId.value)
})

function show(): void {
  popup.value?.show()
}

function hide(): void {
  popup.value?.hide()
}

function goBack(): void {
  selectedId.value = null
}

// Handle transition end to restore scroll position
function onTransitionEnd(): void {
  if (containerRef.value) {
    // If we're in list view (selectedId is null), restore scroll position
    // Otherwise (in detail view), scroll to top
    containerRef.value.scrollTo({
      top: selectedId.value === null ? lastScrollPosition.value : 0,
    })
  }
}

expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "popup",
    ref: popup,
    title: "What's new and features",
    class: "changelog-popup"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "containerRef",
        ref: containerRef,
        class: "changelog-popup__container"
      }, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in",
          onEnter: onTransitionEnd
        }, {
          default: _withCtx(() => [
            (_unref(selectedItem))
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(Item, {
                    item: _unref(selectedItem),
                    isDetail: true,
                    onBack: goBack
                  }, null, 8, ["item"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.view.data, (item) => {
                    return (_openBlock(), _createBlock(Item, {
                      key: item.id,
                      item: item,
                      onClick: ($event: any) => (selectItem(item))
                    }, null, 8, ["item", "onClick"]))
                  }), 128))
                ]))
          ]),
          _: 1
        })
      ], 512)
    ]),
    _: 1
  }, 512))
}
}

})